module.exports = __webpack_public_path__ + "assets/successNote2Speck1-aefdda.svg";